module.exports = __webpack_public_path__ + "img/content_creation_icon.c5540ca3.png";